"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logLevels = void 0;
const logLevels = {
  debug: 20,
  error: 50,
  fatal: 60,
  info: 30,
  trace: 10,
  warn: 40
};
exports.logLevels = logLevels;
//# sourceMappingURL=constants.js.map